<template>
    <div class="titlebar">
        <div class="back-btn" v-if="backPath" @click="handleBackClick">
            <i class="zmdi zmdi-chevron-left text-4xl"></i>
        </div>
        <h1 v-if="isLoading">
            <b-skeleton></b-skeleton>
        </h1>
        <slot v-else></slot>
        <LanguageSelection style="margin-left: auto;" />
    </div>
</template>

<script>

    import LanguageSelection from "@/components/language/LanguageSelection";

    export default {
        name: 'titlebar',
        components: {
            LanguageSelection
        },
        props: {
            incrustation: {
                type: String,
                default: ''
            },
            backPath: {
                type: String | Boolean,
                default: false
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleBackClick: function(){
                if (this.backPath === true) {
                    window.V._router.go(-1);
                } else {
                    window.V._router.push(this.backPath);
                }
            },
        },
      }
</script>

<style lang="scss" scoped>
.titlebar .b-skeleton {
    width: 8em;
    height: 1em;
}
</style>
